import { render, staticRenderFns } from "./dp-header.vue?vue&type=template&id=9dc7e07e&scoped=true"
import script from "./dp-header.vue?vue&type=script&lang=js"
export * from "./dp-header.vue?vue&type=script&lang=js"
import style0 from "./dp-header.vue?vue&type=style&index=0&id=9dc7e07e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc7e07e",
  null
  
)

export default component.exports